import React from "react";
import { Tab } from "semantic-ui-react";

import Footer from "../Footer";
import MenuPagos from "./MenuPagos";

const panes = [
  {
    menuItem: "Operaciones",
    render: () => (
      <Tab.Pane key="131" attached={true}>
        <MenuPagos />{" "}
      </Tab.Pane>
    ),
  },
  // {
  //   menuItem: 'Configuración 1',
  //   render: () => <Tab.Pane key="132" attached={false}>hola 1</Tab.Pane>,
  // },
  // {
  //   menuItem: 'Configuración 2',
  //   render: () => <Tab.Pane key="133" attached={false}>hola 2</Tab.Pane>,
  // },
];

export default function Configuracion() {
  return (
    <div style={{ backgroundColor: "white" }}>
      <br></br>
      <br></br>
      <div>
        <Tab panes={panes} />
      </div>
      <Footer />
    </div>
  );
}
